import { gql } from '@apollo/client';

export const SAVE_COMMISSION_CALCULATION_METHOD = gql`
  mutation saveCommissionCalculationMethod($input: CommissionCalculationMethodInput!) {
    saveCommissionCalculationMethod(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_COMMISSION_CALCULATION_METHOD = gql`
  mutation deleteCommissionCalculationMethod($id: Int!) {
    deleteCommissionCalculationMethod(id: $id) {
      commandId
      correlationId
    }
  }
`;
